import * as OrderTexts from '../../../../../../intl'
import { form } from '../../../formState'
import { Props } from '../typings'

import { Barcodes } from './Barcodes'
import { CustomField } from './CustomField'
import { Note } from './Note'
import { Tags } from './Tags'

export function AdditionalInformation(props: Props) {
  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {OrderTexts.getAdditionalInformationTitle()}
      </form.SectionTitle>
      <Tags {...props} />
      <Note {...props} />
      <CustomField {...props} />
      <Barcodes {...props} />
    </form.Fieldset>
  )
}
